import { styled } from '@ori-ui/mui';
import { StaticNavigationNavigationItemDtoLinkType } from '@ori/static-api-client-react';
import type { StaticApplicationsFooterBffNavigationItemDto } from '@ori/static-api-client-react';
import useTestId from '@ori/testid-generator';
import React from 'react';

const Root = styled('ul')(() => ({
  listStyle: 'none',
  listStyleImage: 'none',
  padding: 0,
  margin: 0,
}));

const ListItem = styled('li')({ lineHeight: '2.5' });

interface Props {
  items?: StaticApplicationsFooterBffNavigationItemDto['children'];
}

export const SiteLinkLinks: React.FC<Props> = ({ items }) => {
  const links = items?.filter((x) => x.linkType === StaticNavigationNavigationItemDtoLinkType.FooterColumnItem);

  const { getTestId } = useTestId();

  return (
    <Root data-testid={getTestId('list')}>
      {links?.map((item, index) => (
        <ListItem key={item.title ?? index}>
          {item.url ? (
            <a
              href={item.url}
              title={item.title ?? ''}
            >
              {item.title}
            </a>
          ) : (
            item.title
          )}
        </ListItem>
      ))}
    </Root>
  );
};
